import { render, staticRenderFns } from "./ChecklistFormDetails.vue?vue&type=template&id=0ace5726"
import script from "./ChecklistFormDetails.vue?vue&type=script&lang=js"
export * from "./ChecklistFormDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports